import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../hooks/useLanguage';

function DefaultSelect({ defaultValue = "regist_date", onChange }) {
    const { t } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(defaultValue);
    const selectRef = useRef(null);

    // sortOptions를 컴포넌트 내부로 이동
    const sortOptions = [
        { name: t('new_arrivals'), value: 'regist_date' },
        { name: t('sort_by_popularity'), value: 'page_view' },
        { name: t('sort_by_price_low'), value: 'low_price' },  
        { name: t('sort_by_price_high'), value: 'high_price' }  
    ];

    const handleClickOutside = (e) => {
        if (selectRef.current && !selectRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // defaultValue가 변경되면 선택 상태도 동기화
    useEffect(() => {
        setSelectedOption(defaultValue);
    }, [defaultValue]);

    const handleOptionClick = (value) => {
        setSelectedOption(value);
        setIsOpen(false);
        if (onChange) {
            onChange(value);
        }
    };

    const getCurrentOptionName = () => {
        const option = sortOptions.find(opt => opt.value === selectedOption);
        return option ? option.name : '';
    };

    return (
        <div ref={selectRef} className={`default_select ${isOpen ? 'open' : ''}`}>
            <button 
                type="button"
                className={`select_btn ${selectedOption ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <span>{getCurrentOptionName()}</span>
            </button>
            <ul className="select_list">
                {sortOptions.map((option) => (
                    <li
                        key={option.value}
                        className={`select_item ${selectedOption === option.value ? 'active' : ''}`}
                        onClick={() => handleOptionClick(option.value)}
                    >
                        {option.name}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default DefaultSelect;
